import React, { useEffect, useRef } from 'react';
import { X } from 'lucide-react';

const ToastNotification = ({ message, type = 'info', onClose }) => {
  // 1. Keep track of the latest onClose function
  // This is necessary because App.jsx refreshes every second, creating a "new" function
  const onCloseRef = useRef(onClose);

  useEffect(() => {
    onCloseRef.current = onClose;
  }, [onClose]);

  // 2. Set the timer EXACTLY ONCE on mount
  useEffect(() => {
    const timer = setTimeout(() => {
      if (onCloseRef.current) {
        onCloseRef.current();
      }
    }, 5000); // 5 seconds fixed

    return () => clearTimeout(timer);
  }, []); // Empty dependency array ensures the timer doesn't reset on updates

  const colors = {
    water: 'bg-cyan-500 border-cyan-400 text-black',
    pill: 'bg-purple-600 border-purple-500 text-white',
    info: 'bg-slate-800 border-slate-700 text-white'
  };

  return (
    <div className="fixed top-24 left-4 right-4 z-[5000] animate-in slide-in-from-top-4 fade-in duration-300">
      <div className={`${colors[type] || colors.info} p-4 rounded-2xl shadow-2xl border-2 flex items-center gap-4 relative`}>
        <div className="text-3xl">
            {type === 'water' ? '💧' : type === 'pill' ? '💊' : 'ℹ️'}
        </div>
        <div className="flex-1">
            <h3 className="font-black uppercase text-sm">{type === 'water' ? 'Hydration Check' : type === 'pill' ? 'Bender Extender' : 'Update'}</h3>
            <p className="text-xs font-bold opacity-90 leading-tight">{message}</p>
        </div>
        <button onClick={onClose} className="absolute top-2 right-2 opacity-60 hover:opacity-100">
            <X size={16} />
        </button>
      </div>
    </div>
  );
};

export default ToastNotification;
